import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { styles } from 'yankees-react-utils';
import { Route, Redirect } from 'react-router-dom';
import RouterTabs from '../../../components/RouterTabs';
import usePlayerSelector from '../../../utils/usePlayerSelector';
import HitterStrengthsOverview from './HItterStrengthsOverview';
import HitterStrengthsDamageZones from './HitterStrengthsDamageZones';
import HitterStrengthsTrends from './HitterStrengthsTrends';
import BatTracking from './BatTracking';
import { HittingMonitor } from '../../../components/HittingMonitor';

const Header = styled.div`
    display: flex;
    justify-content: space-between;
`;

const HitterStrengths = ({ match: { path, url } }) => {
    const { t: translate } = useTranslation();
    const { PlayerID: playerId, Team: { Level: { LevelID: levelId } } } = usePlayerSelector();
    const tabs = [];
    tabs.push({
        key: 'overview',
        path: `${url}/overview`,
        title: translate('sections.reports.hitter.overview-title'),
        component: () => playerId && (
            <HitterStrengthsOverview playerid={playerId} />
        ),
    });
    tabs.push({
        key: 'hitmon',
        path: `${url}/hitmon`,
        title: translate('sections.reports.hitter.hitting-monitor'),
        component: () => playerId && (
            <HittingMonitor playerid={playerId} />
        ),
    });
    tabs.push({
        key: 'trends',
        path: `${url}/trends`,
        title: translate('sections.reports.hitter.trends'),
        component: () => playerId && (
            <HitterStrengthsTrends playerid={playerId} defaultLevelId={levelId} />
        ),
    });
    tabs.push({
        key: 'damage',
        path: `${url}/damage`,
        title: translate('sections.reports.hitter.damage-zones'),
        component: () => playerId && (
            <HitterStrengthsDamageZones playerid={playerId} />
        ),
    });
    tabs.push({
        key: 'bat-tracking',
        path: `${url}/bat-tracking`,
        title: translate('sections.reports.pitcher.bat-tracking-title'),
        component: () => playerId && (
            <BatTracking playerId={playerId} defaultLevelId={levelId} />
        ),
    });
    return (
        <>
            <Route path={path} exact render={() => <Redirect to={{ pathname: `${url}/overview` }} />} />
            <div className="text-center">
                <Header>
                    <h2>{translate('sections.reports.hitter.hitter-strengths')}</h2>
                </Header>
                <RouterTabs tabs={tabs} activeColor={styles.theme.background.gallery} />
            </div>
        </>
    );
};

HitterStrengths.propTypes = {
    match: PropTypes.shape({
        path: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        params: PropTypes.shape({
            gameId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }).isRequired,
    }).isRequired,
};

export default HitterStrengths;
